import log from 'salvo-lite/log'

class KlaviyoForm {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._name = this.constructor.name
    }

    onInit () {
        log.debug(this.constructor.name, 'initalising', this)
        if (window.KlaviyoSubscribe) {
            window.KlaviyoSubscribe.attachToForms(`#${this._elem.getAttribute('id')}`, {
                hide_form_on_success: true,
                success: ($form) => {
                    var form = $form[0]
                    var parent = form.parentElement
                    var toChange = form
                    if (this._emptyParent) {
                        toChange = parent
                    }
                    toChange.innerHTML = '<div class="klaviyo-form__success">Thank you for subscribing.<br>We just sent you an email to confirm your subscription. To finish signing up, please click the confirmation link in the email.</div>'
                    requestAnimationFrame(function () { toChange.querySelector('.klaviyo-form__success').classList.add('shown') })
                }
            })
        }
    }
}

export default KlaviyoForm



// WEBPACK FOOTER //
// ./src/resources/scripts/components/KlaviyoForm.js